// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"71":"manifests.list","74":"order.view","737":"order.list"}[chunkId] || chunkId) + "." + {"71":"5bcc820f","74":"f718bec9","152":"091284e6","181":"b6245b35","737":"d82a3e04"}[chunkId] + ".js";
};